import { billingService } from '@libs/data-access/queries'
import { Button } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { useTrackScheduleFeaturesInteraction } from '@spa/core/externals/segment'
import React from 'react'
import type { FC } from 'react'

import { suspendedSubscriptionModalDef, unpublishModalDef } from '../../Modals'

type Props = {
  weeklyscheduleId: number
}
const UnpublishButton: FC<Props> = ({ weeklyscheduleId }) => {
  const { t } = usePlanningTranslation()
  const scheduleTracker = useTrackScheduleFeaturesInteraction()
  const {
    data: billingAccountStatusData,
    isLoading: isBillingAccountStatusLoading
  } = billingService.account.useGetStatus()
  const { open: openUnpublishModal } = unpublishModalDef.useDispatchModal()
  const { open: openSuspendedModal } =
    suspendedSubscriptionModalDef.useDispatchModal()

  return (
    <Button
      size='s'
      variant='primary'
      intent='danger'
      disabled={isBillingAccountStatusLoading}
      onClick={() => {
        if (billingAccountStatusData?.is_cancelled) {
          openSuspendedModal()
        } else {
          scheduleTracker.publishScheduleMenuOpened('unpublish')
          openUnpublishModal({ weeklyscheduleId })
        }
      }}
    >
      {t('navbar.unpublish')}
    </Button>
  )
}

export default UnpublishButton
